import { SPBlockedReport } from './types';

const SP_BLOCKED_OVERLAY_ID = 'sp-blocked-overlay';

let renderInProgress = false;

const escapeHtml = (value: string): string => {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

const isSPBlockedOverlayMounted = (): boolean => {
    return typeof document !== 'undefined' && document.getElementById(SP_BLOCKED_OVERLAY_ID) !== null;
};

export const isSPBlockedPageShown = (): boolean => isSPBlockedOverlayMounted();

export const fillSPBlockedStubTemplate = (html: string, sp: SPBlockedReport): string => {
    return html
        .replace(/%REQUEST_DATETIME%/g, escapeHtml(sp.datetime))
        .replace(/%REQUEST_IP%/g, escapeHtml(sp.ip))
        .replace(/%REQUEST_ID%/g, escapeHtml(sp.id));
};

const reloadPageOnStubReloadClick = (event: MouseEvent): void => {
    event.preventDefault();
    window.location.reload();
};

const installIframeReloadHandler = (iframe: HTMLIFrameElement): void => {
    const refreshButton = iframe.contentDocument?.querySelector<HTMLElement>('#ButtonRefresh');

    if (!refreshButton) {
        return;
    }

    const refreshButtonClone = refreshButton.cloneNode(true) as HTMLElement;

    refreshButton.replaceWith(refreshButtonClone);
    refreshButtonClone.addEventListener('click', reloadPageOnStubReloadClick);
};

const createSPBlockedOverlay = (html: string): HTMLDivElement => {
    const overlay = document.createElement('div');
    overlay.id = SP_BLOCKED_OVERLAY_ID;
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.zIndex = '2147483647';
    overlay.style.overflow = 'hidden';
    overlay.style.backgroundColor = 'white';

    const iframe = document.createElement('iframe');
    iframe.srcdoc = html;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';
    iframe.style.display = 'block';

    iframe.addEventListener('load', () => installIframeReloadHandler(iframe));
    overlay.appendChild(iframe);

    return overlay;
};

const showSPBlockedOverlay = (html: string): void => {
    if (isSPBlockedOverlayMounted()) {
        return;
    }

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    document.body.appendChild(createSPBlockedOverlay(html));
};

export const renderSPBlockedStub = async(sp: SPBlockedReport): Promise<void> => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    if (isSPBlockedOverlayMounted() || renderInProgress) {
        return;
    }

    renderInProgress = true;

    try {
        const stubUrl = process.env.NEXT_PUBLIC_ANTI_DDOS_STUB_URL;

        if (!stubUrl) {
            showSPBlockedOverlay(sp.html);
            return;
        }

        const response = await fetch(stubUrl);

        if (!response.ok) {
            showSPBlockedOverlay(sp.html);
            return;
        }

        showSPBlockedOverlay(fillSPBlockedStubTemplate(await response.text(), sp));
    } catch {
        showSPBlockedOverlay(sp.html);
    } finally {
        renderInProgress = false;
    }
};
